<template>
  <BModal
    centered
    :title="dialogTitle"
    :id="dialogId"
    :ok-title="okTitle"
    :cancel-title="cancelTitle"
    :cancel-variant="cancelVariant"
    :ok-only="okOnly"
    :ok-disabled="isOkDisabled"
    @ok.prevent="emitOkay"
    :no-close-on-backdrop="noCloseOnBackdrop"
    header-bg-variant="danger"
    title-class="text-white"
    ok-variant="danger"
  >
    <BContainer fluid class="custom-modal-container">
      <BFormRow>
        <slot></slot>
      </BFormRow>
    </BContainer>
  </BModal>
</template>
<script>
export default {
  emits: ["ok"],
  props: {
    dialogId: {
      type: String,
      required: false,
      default: "custom-delete-dialog",
    },
    dialogTitle: {
      type: String,
      required: true,
    },
    okOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
    okTitle: {
      type: String,
      default: "حذف",
    },
    cancelTitle: {
      type: String,
      default: "بستن",
    },
    cancelVariant: {
      type: String,
      default: "",
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
    isOkDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitOkay() {
      this.$emit("ok");
    },
  },
  components: {
    BModal,
    BContainer,
    BFormRow,
    BCol,
  },
};
import { BModal, BContainer, BFormRow, BCol } from "bootstrap-vue";
</script>
<style scoped>
@media only screen and (max-width: 768px) {
  .custom-modal-container {
    max-height: 500px !important;
    overflow-y: auto;
  }
}
@media only screen and (min-width: 769px) {
  .custom-modal-container {
    max-height: 700px !important;
    overflow-y: auto;
  }
}
</style>
